import React, { useMemo } from "react";
import cx from "classnames";

import XtSvg from "components/xt/svg";
import XtInput, { XtInputProps } from "components/xt/input";

import styles from "./index.module.scss";

// interface XtInputSearchProps extends XtInputProps {}

const XtInputSearch: React.FC<XtInputProps> = ({ style, className, value, onInput, ...rest }) => {
  const hasValue = useMemo(() => {
    if (value === 0) return true;
    return !!value;
  }, [value]);
  const onClear = () => {
    onInput && onInput("");
  };

  return (
    <div className={cx(styles.main, className)} style={style}>
      <XtSvg icon={`search`} />
      <XtInput className={styles.input} value={value} onInput={onInput} {...rest} />

      {hasValue && (
        <button onClick={onClear} className={"btnTxt"}>
          <XtSvg icon={`close`} />
        </button>
      )}
    </div>
  );
};

export default XtInputSearch;
